import { DalProvider } from './dal/dal';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class Database {

  private type: string;
  constructor(type?: string) {
    this.type = type;

  }

  getAll(entity?: any) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "select * from " + tableViewName;
        if (entity != null) {
          sqlQuery = sqlQuery + " where "
        }
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {
            sqlQueryFieldsArray.push(key + "=?")
            sqlQueryValuesArray.push(entity[key]);
          } else {
          }

        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(' and ');
        sqlQuery = sqlQuery + sqlQueryFields;
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          var sonuc = [];
          for (var index = 0; index < result.rows.length; index++) {
            var element = result.rows.item(index);
            sonuc.push(element);
          }
          res(sonuc);
        }, function (tx, x) {
          console.log("SQL_ERROR: ", x);
          err(x);
        });
      });
    })
  }

  getAllWithSpecificParams(conditions: string) {
    return new Promise<any[]>((resolve, reject) => {
    });
  }

  getAllWithSpecificQuery(query: string) {
    return new Promise<Array<any>>((res, err) => {
      var db = Database.sqliteWebSqlDbObject();
      var tableName = this.type;
      db.transaction(function (tx) {
        var i = 0;
        var eklenenKayitlar: number[] = [];

        var sqlQuery: string = "";

        sqlQuery = sqlQuery + "select * from " + tableName + " where " + query;
  
        tx.executeSql(sqlQuery, [], function (tx, result) {
          // resolve(result);
          var sonuc = [];
          for (var index = 0; index < result.rows.length; index++) {
            var element = result.rows.item(index);
            sonuc.push(element);
          }
          res(sonuc);


        }, function (tx, x) {
          console.log("SQL_ERROR - GETALL SPEC QUERY: ", x);
          err(x);
        });
      });
    })
  }


  bulkInsert(entities: Array<any>) {
    var tableName = this.type;
    return new Promise((res, err) => {
      var db = Database.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var eklenenKayitlar: number[] = [];
        entities.forEach(entity => {
          i = i + 1;
          var sqlQuery: string = "";
          var sqlQueryFieldsArray: string[] = [];
          var sqlQueryExt: string = "";
          var sqlQueryParamsArray: string[] = [];
          var sqlQueryValuesArray: string[] = [];
          sqlQuery = sqlQuery + "insert into " + tableName + " (";
          sqlQueryExt = sqlQueryExt + " values("
          for (let key in entity) {
            if (entity.hasOwnProperty(key) && typeof key !== 'function') {
              sqlQueryFieldsArray.push(key)
              sqlQueryValuesArray.push(entity[key]);
              sqlQueryParamsArray.push("?");
            } else {
              //alert(key + " is not a public property.");
            }

          }
          var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
          var sqlQueryParams: string = sqlQueryParamsArray.join(',')
          sqlQuery = sqlQuery + sqlQueryFields + ")" + sqlQueryExt + sqlQueryParams + ") ";
          tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
            // resolve(result);
            eklenenKayitlar.push(result.insertId);
            res(eklenenKayitlar);

          }, function (tx, x) {
            console.log("SQL_ERROR - BULK INSERT: ", x);
            err(x);
          });
          if (i >= entities.length) {
            res();
          }
        });
        if (entities.length <= 0) {
          res();
        }
      });
    })
  }


  bulkUpdate(entities: Array<any>, whereCondition: string) {
    var tableName = this.type;
    return new Promise((res, err) => {

      var db = Database.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var guncellenenKayitlar: number[] = [];
        entities.forEach(entity => {
          i = i + 1;
          var sqlQuery: string = "";
          var sqlQueryFieldsArray: string[] = [];
          var sqlQueryValuesArray: string[] = [];
          sqlQuery = sqlQuery + "update " + tableName + " set ";
          // sqlQueryExt = sqlQueryExt + " values("
          for (let key in entity) {
            if (entity.hasOwnProperty(key) && typeof key !== 'function') {
              sqlQueryFieldsArray.push(key + "=?")
              sqlQueryValuesArray.push(entity[key]);
              // sqlQueryParamsArray.push("?");
            } else {
              //alert(key + " is not a public property.");
            }

          }
          sqlQueryValuesArray.push(entity[whereCondition]);
          var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
          sqlQuery = sqlQuery + sqlQueryFields + " WHERE " + whereCondition + " = ?";

          tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
            res(result);
            // guncellenenKayitlar.push(result.insertId);

            console.log("güncelleniyoru",result.insertId)

          }, function (tx, x) {
            console.log("SQL_ERROR - BULK UPDATE: ", x);
            err(x);
          });
          if (i >= entities.length) {
            res(guncellenenKayitlar);
          }
        });
        if (entities.length <= 0) {
          res();
        }

      });
    })
  }

  addOrUpdate(entity) {
    return new Promise((res, err) => {
      var tableName = this.type;
      var db = Database.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryExt: string = "";
        var sqlQueryParamsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "replace into " + tableName + " (";
        sqlQueryExt = sqlQueryExt + " values("
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {
            sqlQueryFieldsArray.push(key)
            sqlQueryValuesArray.push(entity[key]);
            sqlQueryParamsArray.push("?");
          } else {
          }
        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
        var sqlQueryParams: string = sqlQueryParamsArray.join(',')
        sqlQuery = sqlQuery + sqlQueryFields + ")" + sqlQueryExt + sqlQueryParams + ") ";
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          entity.ID = result.insertId;
          res(entity);

        }, function (tx, x) {
          console.log("SQL_ERROR - ADD: ", x);
          err(x);
        });
      });
    })
  }
  add(entity: any) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryExt: string = "";
        var sqlQueryParamsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "insert into " + tableViewName + " (";
        sqlQueryExt = sqlQueryExt + " values("
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {
            sqlQueryFieldsArray.push(key)
            sqlQueryValuesArray.push(entity[key]);
            sqlQueryParamsArray.push("?");
          } else {
          }
        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
        var sqlQueryParams: string = sqlQueryParamsArray.join(',')
        sqlQuery = sqlQuery + sqlQueryFields + ")" + sqlQueryExt + sqlQueryParams + ") ";
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          res();
        }, function (tx, x) {
          console.log("SQL_ERROR: ", x);
          err(x);
        });
      });
    })
  }

  update(entity: any, whereCondition: string) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var guncellenenKayitlar: number[] = [];
        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "update " + tableViewName + " set ";
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {
            sqlQueryFieldsArray.push(key + "=?")
            sqlQueryValuesArray.push(entity[key]);
          } else {

          }
        }
        sqlQueryValuesArray.push(entity[whereCondition]);
        var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
        sqlQuery = sqlQuery + sqlQueryFields + " WHERE " + whereCondition + " = ?";
        console.log("Update query", sqlQuery, sqlQueryValuesArray);
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          res();
        }, function (tx, x) {
          console.log(x);
          err(x);
        });

      });
    })
  }



  delete(entity: any) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "delete from " + tableViewName;
        if (entity != null) {
          sqlQuery = sqlQuery + " where "
        }
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {

            sqlQueryFieldsArray.push(key + "=?")
            sqlQueryValuesArray.push(entity[key]);

          } else {

          }

        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(' and ');
        sqlQuery = sqlQuery + sqlQueryFields;
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          res();
        }, function (tx, x) {
          err(x);
        });
      });
    })
  }

  deleteAll(name: string) {
    return new Promise((resolve, reject) => {
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        tx.executeSql("DELETE FROM " + name, [], function (tx, result) {
          resolve(result);
        }, function (tx, err) {
          reject(err);
        });
      });
    });
  }
  deleteAll2() {
    return new Promise((resolve, reject) => {
      var db = Database.sqliteWebSqlDbObject();
      var tableName = this.type;
      db.transaction(function (tx) {
        tx.executeSql("DELETE FROM " + tableName, [], function (tx, result) {
          resolve(result);
        }, function (tx, err) {
          console.log("SQL_ERROR - DELETE ALL: ", err);
          reject(err);
        });
      });
    });
  }

  execRawQuery(query: string, params?) {
    return new Promise<any>((resolve, reject) => {
      var paramsIn = [];
      if (params != null)
        paramsIn = params;
      var db = Database.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        tx.executeSql(query, paramsIn, function (tx, result) {
          resolve(result);
        }, function (tx, err) {
          console.log("SQL_ERROR - EXEC RAW QUERY: ", err);
          reject(err);
        });
      });
    });
  }

  static sqliteWebSqlDbObject() {
    return DalProvider.connection;
  }

  execRawQueryWithParams(query: string, params: any) {
    return new Promise<any>((resolve, reject) => {
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        tx.executeSql(query, params, function (tx, result) {
          resolve(result);
        }, function (tx, err) {
        });
      });
    });
  }


  sqliteWebSqlDbObject() {
    return DalProvider.connection;
  }

}




// WEBPACK FOOTER //
// ./src/providers/database.ts